import {RsVerification} from "../../api/dto/RsVerification";
import {VerifyService} from "../../service/VerifyService";
import {useCallback} from "react";

interface VerificationViewModelReturn {

    getVerification: (verificationId: string) => Promise<RsVerification>
}

export const VerificationViewModel = () : VerificationViewModelReturn => {

    const getVerification = useCallback(async (verificationId: string): Promise<RsVerification> => {
        return await VerifyService.getInstance().getVerification(verificationId)
    }, [])

    return {
        getVerification
    }
}